module.exports = __webpack_public_path__ + "img/people.fae0c218.png";